// const FETCH_USER_NOTIFICATION_HISTORY_URL = IRIS_API_PREFIX + "/notifications/user/history";
// const FETCH_USER_NOTIFICATION_REPORT_URL = IRIS_API_PREFIX + "/notifications/reports";
// const SEND_CALL_URL = IRIS_API_PREFIX + "/campaigns/send";

import { ISendCallParams } from "../../interfaces/api/iris/sendCall"
import ApiUtils from "../ApiUtils"
import { IIrisServiceApis } from "./IIrisServiceApis"

const IrisUrls = {
	sendCall: "/campaigns/send",
}
export default class IrisServiceApis implements IIrisServiceApis {
	// fetchUserNotificationHistory(req: NotificationReq): Promise<NotificationResponse> {
	// 	return ApiUtils.apiPostRequest(FETCH_USER_NOTIFICATION_HISTORY_URL, JSON.stringify(req));
	// }
	// fetchUserNotificationReport(notificationIds: string[]): Promise<NotificationReport[]> {
	// 	return ApiUtils.apiPostRequest(FETCH_USER_NOTIFICATION_REPORT_URL, JSON.stringify(notificationIds));
	// }
	getServiceUrl = (path: string): string => {
		return "/iris" + path
	}
	sendCall(params: ISendCallParams, tenant: string, authorization: string): Promise<any> {
		const url = this.getServiceUrl(IrisUrls.sendCall)
		return ApiUtils.post(url, params, {
			"x-tenant-id": tenant,
			authorization: authorization,
		})
	}
}
